import React, { useEffect } from 'react';
import {
  useParams,
} from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormShare from '../../forms/FormShare.jsx';

const PageShare = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  useEffect(() => {
    if (_id !== 'new') {
      req({ url: `/api/site/shares/${_id}` });
    }
  }, [_id]);

  const breadcrumb = _id === 'self' ? [] : [
    { to: '../', children: 'Shares' },
  ];

  return _id === 'new' ? (
    <>
      <Header breadcrumb={breadcrumb}>New Share</Header>
      <FormShare />
    </>
  ) : (
    <PageHttp res={res}>
      {(doc) => (
        <>
          <Header breadcrumb={breadcrumb}>Edit</Header>
          <FormShare
            share={doc}
          />
        </>
      )}
    </PageHttp>
  );
};

export default PageShare;
